import { render, staticRenderFns } from "./DuelsGames.vue?vue&type=template&id=55b346ac&scoped=true"
import script from "./DuelsGames.vue?vue&type=script&lang=js"
export * from "./DuelsGames.vue?vue&type=script&lang=js"
import style0 from "./DuelsGames.vue?vue&type=style&index=0&id=55b346ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b346ac",
  null
  
)

export default component.exports